/**
 * 泰语（th）
 */

import thLocale from 'element-ui/lib/locale/lang/th'

export default {
  ...thLocale,
  common: {},
  // 语言
  lang: {
    english: 'ภาษาอังกฤษ',
    spanish: 'ภาษาสเปน',
    japanese: 'คนญี่ปุ่น',
    portuguese: 'ภาษาโปรตุเกส',
    french: 'ภาษาฝรั่งเศส',
    russian: 'ภาษารัสเซีย',
    arabic: 'ภาษาอาหรับ',
    german: 'ภาษาเยอรมัน',
    italian: 'ชาวอิตาเลียน',
    vietnam: 'เวียดนาม•',
    turkey: 'ตุรกี',
    korean: 'คนเกาหลี',
    thai: 'คนไทย',
    dutch: 'ดัตช์',
    hebrew: 'ภาษาฮิบรู',
    indonesian: 'ภาษาอินโดนีเซีย'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {}

  // 张丰

  // 孙泽严
}
